module.exports = __webpack_public_path__ + "images/video_min.jpg?8d9b1eff3e5e0cc3354a2693c920ac0d";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/assets/images/video_min.jpg
// module id = 978
// module chunks = 0